import { j as json } from "../../../../chunks/index2.js";
import admin from "firebase-admin";
const GET = async ({ url }) => {
  const { searchParams } = url;
  const email = searchParams.get("email");
  if (email) {
    const docRef = admin.firestore().collection("users").doc(email);
    const user = await docRef.get();
    if (user.exists) {
      return json(user.data());
    }
    return json({ error: "User not found" }, { status: 404 });
  }
  return json({ error: "No query provided" }, { status: 400 });
};
const POST = async ({ request }) => {
  try {
    const body = await request.json();
    const docRef = admin.firestore().collection("users").doc(body.id);
    await docRef.set(body, { merge: true });
    return json(body);
  } catch (err) {
    console.log(err);
    return json({ error: "Failed to create user" }, { status: 500 });
  }
};
export {
  GET,
  POST
};
